import {
  RECEIVE_BILLABLETYPE,
  RECEIVING_BILLABLETYPE,
  RECEIVE_BILLABLETYPE_METADATA,
  SAVING_BILLABLETYPE,
  UPDATING_BILLABLETYPE,
  DELETE_BILLABLETYPE,
  DELETING_BILLABLETYPE,
  RESET_BILLABLETYPE_META,
  CLEAR_BILLABLETYPE_STATE,
  CLEAR_STATE,
  INCREMENT_BILLABLETYPE_COUNT,
  SET_ALL_BILLABLETYPE_LOADED
} from '@/store/mutationTypes'
import {
  receiveData,
  deleteData,
  increment,
  receiveMetadata,
  resetMetadata,
  clearLocalState,
  clearState
} from '@/store/modules/helpers/mutationHelpers'

const state = {
  data: {},
  cache: {},
  count: null,
  shown: null,
  currentPage: 1,
  saving: false,
  receivingData: false,
  updating: null,
  deleting: false,
  allBillabletypeLoaded: false
}

const actions = {
  setBillabletypePreloadStatus (store, payload) {
    this.commit(SET_ALL_BILLABLETYPE_LOADED, payload)
  },
  clearBillabletypeState (store, clearCache = false) {
    this.commit(CLEAR_BILLABLETYPE_STATE, clearCache)
  }
}

const getters = {
  getBillabletype: (state) => {
    return state.data ? Object.values(state.data).map(v => Object.assign({}, v)) : []
  },
  getAllBillabletype: (state) => {
    return state.cache ? Object.values(state.cache).map(v => Object.assign({}, v)) : []
  },
  getBillabletypeMetadata: (state) => {
    const { shown, count } = state
    if (!shown) return { count: 0, shown: 0 }
    return { count, shown }
  },
  getBillabletypeById: (state, rootState) => (id) => {
    if (state.data && state.data[id]) {
      return state.data[id]
    } else if (state.cache && state.cache[id]) {
      return state.cache[id]
    } else {
      return {}
    }
  },
  getDefaultBillabletype: (state) => {
    return Object.values(state.cache).find(v => v.active) || {}
  },
  getBillabletypeFetchStatus: (state) => {
    return state.receivingData
  },
  getBillabletypeSaveStatus: (state) => {
    return state.saving
  },
  getBillabletypeUpdateStatus: (state) => {
    return state.updating
  },
  getBillabletypeDeleteStatus: (state) => {
    return state.deleting
  }
}

const mutations = {
  [RECEIVE_BILLABLETYPE] (state, results) {
    receiveData(state, results)
  },
  [RECEIVING_BILLABLETYPE] (state, payload) {
    state.receivingData = payload
  },
  [SAVING_BILLABLETYPE] (state, payload) {
    state.saving = payload
  },
  [UPDATING_BILLABLETYPE] (state, payload) {
    state.updating = payload
  },
  [DELETE_BILLABLETYPE] (state, payload) {
    deleteData(state, payload)
  },
  [DELETING_BILLABLETYPE] (state, payload) {
    state.deleting = payload
  },
  [INCREMENT_BILLABLETYPE_COUNT] (state, payload) {
    increment(state, payload)
  },
  [RECEIVE_BILLABLETYPE_METADATA] (state, payload) {
    receiveMetadata(state, payload)
  },
  [CLEAR_BILLABLETYPE_STATE] (state, payload) {
    clearLocalState(state, payload)
  },
  [RESET_BILLABLETYPE_META] (state) {
    resetMetadata(state)
  },
  [CLEAR_STATE] (state) {
    clearState(state)
  },
  [SET_ALL_BILLABLETYPE_LOADED] (state, payload) {
    state.allBillabletypeLoaded = payload
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
